import { GatewayStatus } from 'constants/gatewayStatuses';
import { Resources } from 'constants/resources';

import { useGetList } from 'react-admin';
import { Controller, useFormContext } from 'react-hook-form';
import { GatewayStatusIcon } from 'shared/mui/Icons/GatewayStatusIcon/GatewayStatusIcon';
import { InputLabel } from 'shared/mui/Labels/InputLabel/InputLabel';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';
import { Select } from 'shared/mui/Select/Select';
import { GatewayStatus as GatewayStatusType } from 'types/embedded/gateway';

import { FormControlStyled, menuStyles } from './GatewaysListFilterStatusSelectInput.styled';

export const GatewaysListFilterStatusSelectInput = () => {
  const { control } = useFormContext();
  const { data: gatewayStatuses } = useGetList<GatewayStatusType>(Resources.GatewayStatuses);

  return (
    <Controller
      control={control}
      name="status"
      render={({ field }) => (
        <FormControlStyled fullWidth sx={{ minWidth: 0 }}>
          <InputLabel shrink>Статус</InputLabel>
          <Select
            MenuProps={{ sx: menuStyles }}
            fullWidth
            label="Статус"
            notched
            onChange={(value) => {
              field.onChange(value);
            }}
            size="small"
            value={field.value || ''}
            variant="outlined"
          >
            <MenuItem value="" />
            {gatewayStatuses?.map((status) => (
              <MenuItem key={status.id} value={status.id}>
                <GatewayStatusIcon status={status.value as GatewayStatus} />
                <span>{status.description}</span>
              </MenuItem>
            ))}
          </Select>
        </FormControlStyled>
      )}
    />
  );
};
